import { defineComponent as _defineComponent } from 'vue'
import type { Router } from 'vue-router';
import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'NotFoundView',
  setup(__props) {

const router: Router = useRouter();

router.push({ name: 'home' });

return () => {}
}

})